import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { ChangePasswordParamsType } from '@model/change-password-params';

const BTN_TYPE_CONSTANT = 'BTN';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router: Router;
  private readonly route: ActivatedRoute;

  constructor(private readonly injector: Injector) {
    this.router = this.injector.get(Router);
    this.route = this.injector.get(ActivatedRoute);
  }
  public redirectToLogin(): void {
    const params = this.getParams();
    const externalUrl = this.resolveExternalUrl(params);

    if (externalUrl) {
      window.location.href = externalUrl;
      return;
    }

    this.router.navigate(['/login']);
  }

  private resolveExternalUrl({ allianceCode, transactionId, type }: ChangePasswordParamsType): string | null {
    if (allianceCode && transactionId && type === BTN_TYPE_CONSTANT) {
      return `${environment.checkoutUrl}?${new URLSearchParams({ allianceCode, transactionId })}`;
    }
    if (allianceCode) {
      return `${environment.alliancesUrl}/login?${new URLSearchParams({ allianceCode })}`;
    }
    return null;
  }

  private getParams(): ChangePasswordParamsType {
    const params = this.route.snapshot.queryParamMap;

    return {
      allianceCode: params.get('allianceCode') ?? undefined,
      transactionId: params.get('transactionId') ?? undefined,
      type: params.get('type') ?? undefined,
    };
  }
}
